import { Gift } from "lucide-react";
import { ReferralCard } from "@/components/ReferralCard";
import { useI18n } from "@/context/I18nContext";

export default function ReferralPage() {
  const { t } = useI18n();
  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="referral-page">
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-espresso flex items-center gap-2">
          <Gift className="w-7 h-7 text-olive" />
          {t("ref.title")}
        </h1>
        <p className="text-sm text-espresso/70 mt-1">{t("ref.sub")}</p>
      </div>
      <ReferralCard />
    </div>
  );
}
